/* eslint-disable import/prefer-default-export */
/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { get, isString } from 'lodash';
import env from 'utils/env';

interface BaseResponse<T> {
  data: T | null;
  statusCode: number;
  error: boolean;
  errorMessage?: string;
}

function handleError(err: any) {
  const status = get(err, 'response.status') as number;
  const data = get(err, 'response.data');

  if (status >= 500) {
    throw new Error('Server Error');
  }

  let errorMessage = get(data, 'detail', `Unknown Error: ${status}`);
  if (!isString(errorMessage)) {
    errorMessage = 'Bad Request';
  }

  return {
    data: null,
    statusCode: status,
    errorMessage,
    error: true
  };
}

export async function doPost<Response, Body>(
  url: string,
  body: Body,
  headers: any = {}
): Promise<BaseResponse<Response>> {
  try {
    const { data, status } = await axios.post<Response>(url, body, {
      headers: {
        ...headers
      }
    });

    return {
      error: false,
      data,
      statusCode: status
    };
  } catch (err) {
    return handleError(err);
  }
}

export async function doGet<Query, Response>(
  url: string,
  query: Query,
  headers: any = {}
): Promise<BaseResponse<Response>> {
  try {
    const config = env();
    const { data, status } = await axios.get<Response>(
      `${config.userServerApiUrl}/user/${url}`,
      {
        data: query,
        headers: {
          ...headers
        }
      }
    );

    return {
      error: false,
      data,
      statusCode: status
    };
  } catch (err) {
    return handleError(err);
  }
}

export async function doGetClubsServer<Query, Response>(
  url: string,
  query: Query,
  headers: any = {}
): Promise<BaseResponse<Response>> {
  try {
    const config = env();
    const { data, status } = await axios.get<Response>(
      `${config.baseApiUrl}/${url}`,
      {
        data: query,
        headers: {
          ...headers,
        },
      }
    );

    return {
      error: false,
      data,
      statusCode: status,
    };
  } catch (err) {
    return handleError(err);
  }
}

export async function doPostForm<Response>(
  url: string,
  formData: FormData,
  headers: any = {}
): Promise<BaseResponse<Response>> {
  try {
    const config = env();

    const { data, status } = await axios({
      method: 'post',
      url: `${config.userServerApiUrl}/user/${url}`,
      data: formData,
      headers: {
        ...headers,
        'Content-Type': 'multipart/form-data'
      }
    });

    return {
      error: false,
      data,
      statusCode: status
    };
  } catch (err) {
    return handleError(err);
  }
}

export async function doDelete<Query, Response>(
  url: string,
  query: Query,
  headers: any = {}
): Promise<BaseResponse<Response>> {
  try {
    const config = env();
    const { data, status } = await axios.delete<Response>(
      `${config.userServerApiUrl}/user/${url}`,
      {
        data: query,
        headers: {
          ...headers
        }
      }
    );

    return {
      error: false,
      data,
      statusCode: status
    };
  } catch (err) {
    return handleError(err);
  }
}

export async function doUpdateUserProfile<Response>(
  url: string,
  formData: {},
  headers: any = {}
): Promise<BaseResponse<Response>> {
  try {
    const { data, status } = await axios({
      method: 'patch',
      url: url,
      data: JSON.stringify(formData),
      headers: {
        ...headers,
        'Content-Type': 'application/json'
      }
    });

    return {
      error: false,
      data,
      statusCode: status
    };
  } catch (err) {
    return handleError(err);
  }
}
